<div class="advantage">
  <owl-carousel-o
    [options]="topProductsOptions"
    class="block-md hidden advantage-carousel"
  >
    <ng-template *ngFor="let advantage of advantageDatasourceService.advantages" carouselSlide>
      <app-advantage-item
        [imageLink]="advantage.image"
        [title]="advantage.title"
        [description]="advantage.description"
      ></app-advantage-item>
    </ng-template>
  </owl-carousel-o>

  <div class="advantage-container">
    <ng-container *ngFor="let advantage of advantageDatasourceService.advantages">
      <app-advantage-item
        [imageLink]="advantage.image"
        [title]="advantage.title"
        [description]="advantage.description"
      ></app-advantage-item>
    </ng-container>
  </div>
</div>
